import foodChallengeIcon from '../assets/icons/food-challenge.svg';
import groupChallengeIcon from '../assets/icons/group-challenge.svg';
import friendChallengeIcon from '../assets/icons/friend-challenge.svg';
import bagChallengeIcon from '../assets/icons/bag.svg';
import storeChallengeIcon from '../assets/icons/store.svg';
import locationChallengeIcon from '../assets/icons/location.svg';
import puzzleChallengeIcon from '../assets/icons/puzzle.svg';
import footballChallengeIcon from '../assets/icons/football.svg';
import starChallengeIcon from '../assets/icons/star.svg';
import planeChallengeIcon from '../assets/icons/plane.svg';
import cardChallengeIcon from '../assets/icons/card.svg';
import calendarChallengeIcon from '../assets/icons/calendar.svg';

export const CHALLENGE_TYPES = [
  {
    value: 'eat_restaurants',
    group: 'Missions',
    label: 'Eat in-network restaurants',
    hint: 'Eat at unique in-network restaurants',
    title: 'Eat at 2 in-network restaurants this week',
    subtitle: 'Visit unique Olive restaurants',
    goal: 'count',
    countLabel: 'Number of restaurants',
    countDefault: 2,
    icon: foodChallengeIcon,
    iconKey: 'food',
  },
  {
    value: 'in_network_purchases',
    group: 'Missions',
    label: 'In-network purchases',
    hint: 'Make in-network purchases',
    title: 'Make 2 in-network purchases this week',
    subtitle: 'Shop at Olive merchants',
    goal: 'count',
    countLabel: 'Number of purchases',
    countDefault: 2,
    icon: bagChallengeIcon,
    iconKey: 'bag',
  },
  {
    value: 'check_in_streak',
    group: 'Missions',
    label: 'Check in at games in a row',
    hint: 'Check in at consecutive games',
    title: 'Check in at 2 games in a row',
    subtitle: 'Back-to-back game check-ins',
    goal: 'count',
    countLabel: 'Games in a row',
    countDefault: 2,
    icon: locationChallengeIcon,
    iconKey: 'location',
  },
  {
    value: 'extension_purchase',
    group: 'Missions',
    label: 'Safari extension purchase',
    hint: 'Buy something through the Safari extension',
    title: 'Buy something through the Safari extension',
    subtitle: 'Complete an extension purchase',
    goal: 'count',
    countLabel: 'Number of purchases',
    countDefault: 1,
    icon: puzzleChallengeIcon,
    iconKey: 'puzzle',
  },
  {
    value: 'predict_scores',
    group: 'Missions',
    label: 'Predict game scores',
    hint: 'Predict the score on games',
    title: 'Predict the score on 2 games this week',
    subtitle: 'Make score predictions',
    goal: 'count',
    countLabel: 'Number of games',
    countDefault: 2,
    icon: footballChallengeIcon,
    iconKey: 'football',
  },
  {
    value: 'spend_in_network',
    group: 'Missions',
    label: 'Spend in-network',
    hint: 'Spend a dollar amount at Olive merchants',
    title: 'Spend $50 in-network this month',
    subtitle: 'In-network spend goal',
    goal: 'spend',
    spendDefault: 50,
    icon: storeChallengeIcon,
    iconKey: 'store',
  },
  {
    value: 'new_restaurant',
    group: 'Missions',
    label: 'Try a new restaurant',
    hint: 'An in-network restaurant you have never tried',
    title: "Try an in-network restaurant you've never tried",
    subtitle: 'First visit to a new Olive restaurant',
    goal: 'count',
    countLabel: 'New restaurants',
    countDefault: 1,
    icon: foodChallengeIcon,
    iconKey: 'food',
  },
  {
    value: 'earn_points',
    group: 'Missions',
    label: 'Earn points',
    hint: 'Earn a points total in the challenge window',
    title: 'Earn 500 points in a week',
    subtitle: 'Hit a personal points target',
    goal: 'points',
    pointsDefault: 500,
    icon: starChallengeIcon,
    iconKey: 'star',
  },
  {
    value: 'book_travel',
    group: 'Missions',
    label: 'Book travel or attraction',
    hint: 'Book travel or an attraction',
    title: 'Book travel or an attraction',
    subtitle: 'Complete a travel or attraction booking',
    goal: 'count',
    countLabel: 'Number of bookings',
    countDefault: 1,
    icon: planeChallengeIcon,
    iconKey: 'plane',
  },
  {
    value: 'card_draw',
    group: 'Missions',
    label: 'Draw a card',
    hint: 'Draw a card on separate days',
    title: 'Draw a card 5 days this month',
    subtitle: 'Daily card draws',
    goal: 'count',
    countLabel: 'Days to draw',
    countDefault: 5,
    icon: cardChallengeIcon,
    iconKey: 'card',
  },
  {
    value: 'game_day_double',
    group: 'Missions',
    label: 'Game day double',
    hint: 'Check in and shop in-network in the same window',
    title: 'Game day double: check in and shop in-network the same week',
    subtitle: 'Check in and make an in-network purchase',
    goal: 'combo',
    icon: calendarChallengeIcon,
    iconKey: 'calendar',
  },
  // {
  //   value: 'squad_goals',
  //   group: 'Social',
  //   label: 'Squad Goals',
  //   hint: 'Up to 4 people collect a points target together. Everyone on the squad gets the reward points.',
  //   title: 'Squad Goals',
  //   subtitle: 'Team Up for 4 Tickets',
  //   reward_label: 'Entry reward',
  //   goal: 'squad',
  //   pointsDefault: 500,
  //   icon: groupChallengeIcon,
  // },
  // {
  //   value: 'friend_challenge',
  //   group: 'Social',
  //   label: 'Friend Challenge',
  //   hint: 'Invite a friend. Play together or versus.',
  //   title: 'Friend Challenge',
  //   subtitle: 'Outscore a friend',
  //   reward_label: 'Game tickets',
  //   goal: 'friend',
  //   icon: friendChallengeIcon,
  // },
];

export const TYPE_GROUPS = ['Missions']; // , 'Social'];
export const TYPE_BY_VALUE = Object.fromEntries(CHALLENGE_TYPES.map(type => [type.value, type]));
TYPE_BY_VALUE.eat_local = {
  ...TYPE_BY_VALUE.eat_restaurants,
  value: 'eat_local',
  label: 'Eat Local',
  title: 'Eat Local',
  icon: foodChallengeIcon,
  iconKey: 'food',
};

export const STOCK_CHALLENGE_ICONS = [
  { key: 'food', src: foodChallengeIcon, label: 'Food' },
  { key: 'bag', src: bagChallengeIcon, label: 'Bag' },
  { key: 'store', src: storeChallengeIcon, label: 'Store' },
  { key: 'location', src: locationChallengeIcon, label: 'Location' },
  { key: 'puzzle', src: puzzleChallengeIcon, label: 'Puzzle' },
  { key: 'football', src: footballChallengeIcon, label: 'Football' },
  { key: 'star', src: starChallengeIcon, label: 'Star' },
  { key: 'plane', src: planeChallengeIcon, label: 'Plane' },
  { key: 'card', src: cardChallengeIcon, label: 'Card' },
  { key: 'calendar', src: calendarChallengeIcon, label: 'Calendar' },
  { key: 'group', src: groupChallengeIcon, label: 'Group' },
  { key: 'friend', src: friendChallengeIcon, label: 'Friend' },
];

export const ICON_KEY_FOR_TYPE = Object.fromEntries(
  Object.values(TYPE_BY_VALUE).map(type => [type.value, type.iconKey]).filter(entry => entry[1])
);

export const defaultIconKeyForType = type => ICON_KEY_FOR_TYPE[type] || 'food';

export const challengeIcon = type => TYPE_BY_VALUE[type]?.icon || null;

export const resolveChallengeIcon = item => {
  if (item?.icon_url) return item.icon_url;
  const key = item?.icon_key || ICON_KEY_FOR_TYPE[item?.challenge_type];
  return STOCK_CHALLENGE_ICONS.find(stock => stock.key === key)?.src || challengeIcon(item?.challenge_type);
};

export const PARTY_SIZES = [
  { value: 'solo', label: 'Solo' },
  // { value: 'duo', label: 'Duo' },
  // { value: 'trio', label: 'Trio' },
  // { value: 'quadro', label: 'Quadro' },
];

export const MATCH_MODES = [
  { value: 'together', label: 'Together' },
  { value: 'versus', label: 'Versus' },
];

export const defaultPartyForType = type => {
  // if (type?.goal === 'friend') return { party_size: 'duo', match_mode: 'versus' };
  // if (type?.goal === 'squad') return { party_size: 'quadro', match_mode: 'together' };
  return { party_size: 'solo', match_mode: 'together' };
};

export const partySummary = item => {
  const party = PARTY_SIZES.find(entry => entry.value === item?.party_size)?.label;
  if (!party) return '';
  if (item.party_size === 'solo') return party;
  const mode = MATCH_MODES.find(entry => entry.value === item?.match_mode)?.label;
  return [party, mode].filter(Boolean).join(' · ');
};

export const goalSummary = item => {
  const meta = TYPE_BY_VALUE[item.challenge_type] || {};
  const party = partySummary(item);
  let goal = '';
  if (item.challenge_type === 'squad_goals') {
    goal = `${item.target_points} team points`;
  } else if (item.challenge_type === 'friend_challenge') {
    goal = item.match_mode === 'versus' ? 'Points race' : 'Shared goal';
  } else if (item.challenge_type === 'game_day_double') {
    goal = 'Check in and shop in-network in the same window';
  } else if (meta.goal === 'spend' && item.target_spend_cents) {
    goal = `Spend $${(item.target_spend_cents / 100).toFixed(item.target_spend_cents % 100 === 0 ? 0 : 2)} in-network`;
  } else if (meta.goal === 'points' && item.target_points) {
    goal = `Earn ${item.target_points} points`;
  } else {
    const count = item.required_count || item.required_purchases;
    if (count) {
      goal = `${count} ${(meta.countLabel || 'required').toLowerCase()}`;
    } else {
      goal = meta.hint || '';
    }
  }
  return [party, goal].filter(Boolean).join(' · ');
};
